import { editOperatorConfigService, fetchOperatorConfigDetails } from "../../services/operatorConfigEdit";
import { fetchOperatorConfig } from "../actions/operatorConfigEdit";
import { createAllActionCreators } from "./actionCreatorUtil";

const operatorConfigEditCreators = {
  editOperatorConfigAction: {
    service: editOperatorConfigService,
    responseNotification: {
      status: true,
      only: true,
    },
  },
  fetchOperatorConfigAction: {
    service: fetchOperatorConfigDetails,
    action: fetchOperatorConfig,
  },
};

export const {
  editOperatorConfigAction,
  fetchOperatorConfigAction,
} = createAllActionCreators(operatorConfigEditCreators);
